var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Home"}},[_c('HeroSlider'),_c('Benefits'),_c('Create'),_c('BookSuiteForm'),_c('Modal',{attrs:{"modalActive":_vm.modalActive},on:{"modalHide":_vm.modalHide}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }